import { render, staticRenderFns } from "./LeftTopBar.vue?vue&type=template&id=4c55efea&scoped=true&"
import script from "./LeftTopBar.vue?vue&type=script&lang=js&"
export * from "./LeftTopBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c55efea",
  null
  
)

export default component.exports